module.exports = __webpack_public_path__ + "img/time.b955a77f.svg";